import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Alert, MenuItem, Stack, TextField, Typography,
} from '@mui/material';
import { sessionActions } from '../store';
import { request, useOperations } from './OperationsProvider';

// Which gate this desk is standing at.
//
// It belongs to the person rather than to the browser: an operator who moves from the north gate to
// the south gate at the start of a shift says so here, and it follows them to whichever terminal
// they sign in on. Everything downstream reads it — the routes offered are the ones that start at
// this gate, and the direction offered is the traffic the gate takes.
const PostedGate = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session.user);
  const { data } = useOperations();
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(false);
  const gates = (data.checkpoints || []).filter((c) => c.type === 'GATE_IN' || c.type === 'GATE_OUT');
  const posted = user?.postedCheckpointId ?? '';

  const choose = async (value) => {
    setPending(true); setError(null);
    try {
      const updated = await request('/api/session', 'PATCH', { name: user.name, postedCheckpointId: value === '' ? null : value });
      dispatch(sessionActions.updateUser(updated));
    } catch (err) {
      setError(err.message);
    } finally {
      setPending(false);
    }
  };

  if (!gates.length) {
    return <Typography variant="caption" color="text.secondary">No gates are defined yet. A tenant administrator adds them under Configuration.</Typography>;
  }
  return (
    <Stack spacing={1}>
      <TextField
        select
        size="small"
        disabled={pending}
        label="You are at"
        value={gates.some((g) => g.id === posted) ? posted : ''}
        onChange={(event) => choose(event.target.value)}
        sx={{ minWidth: 220 }}
        helperText={posted ? 'Routes and direction follow this gate.' : 'Set your gate to see only the routes that start here.'}
      >
        <MenuItem value="">Any gate</MenuItem>
        {gates.map((gate) => (
          <MenuItem key={gate.id} value={gate.id}>
            {gate.handles && gate.handles !== 'BOTH' ? `${gate.name} · ${gate.handles.toLowerCase()} only` : gate.name}
          </MenuItem>
        ))}
      </TextField>
      {error && <Alert severity="warning">{error}</Alert>}
    </Stack>
  );
};

export default PostedGate;
